import { ShieldCheck, BadgeCheck, User, Globe, Store, Sparkles } from "lucide-react";

// One canonical, color-coded trust badge used everywhere (AI sources, state pages,
// data-entry provenance). Mirrors the backend hr_trust.TIERS taxonomy.
export const TIER_UI = {
  official: { label: "Official Source", Icon: ShieldCheck, cls: "text-[#2E7D46] border-[#2E7D46]/40 bg-[#2E7D46]/10" },
  verified: { label: "HomeRange Verified", Icon: BadgeCheck, cls: "text-forest border-forest/40 bg-forest/10" },
  community: { label: "Hunter-entered", Icon: User, cls: "text-slate-500 border-slate-400/40 bg-slate-400/10" },
  third_party: { label: "Third-party", Icon: Globe, cls: "text-amber-600 border-amber-500/40 bg-amber-500/10" },
  partner: { label: "HomeRange Partner", Icon: Store, cls: "text-saddle border-saddle/40 bg-saddle/10" },
  ai: { label: "AI-generated", Icon: Sparkles, cls: "text-violet-500 border-violet-400/40 bg-violet-400/10" },
};

export function SourceBadge({ tier = "ai", label, size = "sm", className = "" }) {
  const t = TIER_UI[tier] || TIER_UI.ai;
  const Icon = t.Icon;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[10px] gap-1" : "px-2 py-0.5 text-[11px] gap-1.5";
  const iconSize = size === "xs" ? 10 : 12;
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold uppercase tracking-wide ${t.cls} ${pad} ${className}`}
      data-testid={`source-badge-${tier}`}
      title={t.label}
    >
      <Icon size={iconSize} className="shrink-0" />
      {label || t.label}
    </span>
  );
}
